import { withDataVersion } from '@hakimo-ui/hakimo/util';
import {
  DataVersion,
  UpsertLocationAlarmIncidentDTO,
  UpsertLocationAlarmIncidentResponseDTO,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useCreateLocationAlarmIncident(
  // Receives the created *or* existing incident: on v3 a repeat escalation in
  // the same source group returns the group's active one, whose `incident_id`
  // and `location_alarm_id` may name a different alarm. Only `message` is read
  // today, to tell a create from a dedup; the ids are not adopted anywhere.
  onSuccess?: (data: UpsertLocationAlarmIncidentResponseDTO) => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/location_incidents/`;

  const request = new Request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<
    UpsertLocationAlarmIncidentResponseDTO,
    UpsertLocationAlarmIncidentDTO | null
  >(request, {
    onSuccessInvalidationKeys: [
      ['locationAlarms'],
      ['location_alarm_updates'],
      // The new/returned incident changes what the incident surfaces show.
      ['locationIncidents'],
      ['incidentDetail'],
    ],
    onSuccess,
    onError,
  });
}

export default useCreateLocationAlarmIncident;
